/**
 * 统一的API基础配置
 * 确保所有API都使用相同的认证配置
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '../index';
import i18n from '../../i18n';

// 统一的基础查询配置
export const createBaseQuery = (baseUrl?: string) => {
  return fetchBaseQuery({
    baseUrl: baseUrl || '/api/v1', // 使用代理

    // 统一的请求头处理
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const token = state.auth.token;

      // 添加认证头
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        console.log('API请求添加认证头', {
          userRole: state.auth.user?.role,
          userName: state.auth.user?.name,
          api: baseUrl || 'default',
        });
      } else {
        console.warn('API请求缺少认证token', { api: baseUrl || 'default' });
      }

      // 设置内容类型
      if (!headers.get('content-type')) {
        headers.set('content-type', 'application/json');
      }

      // 优先使用用户手动选择并持久化的语言，避免被浏览器默认语言覆盖
      const persistedLanguage =
        typeof window !== 'undefined'
          ? localStorage.getItem('greenbond_language')
          : null;
      const currentLanguage = persistedLanguage || i18n.language || 'en';

      // 传递当前前端语言，供后端返回本地化展示字段
      headers.set('x-language', currentLanguage);
      headers.set('accept-language', currentLanguage);

      return headers;
    },
  });
};

// 统一的错误处理
export const handleApiError = (error: any) => {
  if (error?.status === 401) {
    // 认证失败，清除本地存储的认证信息
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('user');

    // 重定向到登录页面
    window.location.href = '/auth/login';
  }

  return error;
};

// 创建带统一配置的API
export const createUnifiedApi = (
  reducerPath: string,
  tagTypes: string[] = []
) => {
  return createApi({
    reducerPath,
    baseQuery: createBaseQuery(),
    tagTypes,
    endpoints: () => ({}),
  });
};
